import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { HighlightBarBlock as HighlightBarBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";

import styles from "./index.module.scss";

type IProps = Immutable<
    | { className?: string; html: string | null | undefined; children?: never }
    | { className?: string; html?: never; children: React.ReactNode }
>;

export const HighlightBar = (props: IProps): React.JSX.Element => {
    const className = concatClassNames([styles.highlightBar, props.className]);
    if (props.html !== undefined) {
        return (
            <section
                className={className}
                dangerouslySetInnerHTML={richHTML(props.html)}
            />
        );
    }
    return <section className={className}>{props.children}</section>;
};

export const HighlightBarBlock = (
    props: Immutable<{ value: HighlightBarBlockValue }>,
): React.JSX.Element => (
    <HighlightBar
        className={getGlobalSpacingClasses(props.value.spacing)}
        html={props.value.copy}
    />
);
